<template>
    <v-dialog scrollable  fullscreen v-model="dialog" transition="dialog-bottom-transition" >

        <v-card class="mt-4 pt-4">
          <v-card-title class="primary white--text" fixed>
            <v-btn icon dark @click="hide" class="mr-1">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            Editar {{getLabel('commons.client.singular')}}
            <v-spacer></v-spacer>
            <v-btn :loading="loading" :disabled="!validClient" color="primary" depressed dark @click="saveClient">Guardar</v-btn>
          </v-card-title>
            <v-card-text>
                <v-container mt-4>
                    <v-layout wrap align-center justify-center>
                        <v-flex xs12 md8 lg6  pt-4 mt-4>
                            <v-layout wrap>
                                <template v-if="client">
                                    <v-slide-y-transition>
                                        <v-flex v-show="client" xs12  text-center>
                                            <patient-form
                                                :required-fields="requiredFields"
                                                :requested-fields="requestedFields"
                                                ref="patientForm"
                                                :value="client || null"
                                                v-on:update:valid="validClient = $event"/>
                                        </v-flex>
                                    </v-slide-y-transition>
                                </template>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

    import PatientForm from '@/components/common/signup/PatientForm'

    import {ApiUtils} from '@/utils/ApiUtils'
    import {getLabel} from '@/utils/Institution'

    import {mapState, mapMutations} from 'vuex'

    export default{
        components: {
            PatientForm
        },
        props: {
            requiredFields:{
                type: Array
            },
            requestedFields:{
                type: Array
            }
        },
        data(){
            return {
                dialog: false,
                other: false,
                editClient: false,
                reason: null,
                client: null,
                loading: false,
                validClient: true,
                rules: [
                    v => !!v || 'Este campo es obligatorio',
                    v => v.length > 10 || 'Requiere al menos 10 caracteres',
                ]
            }
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            getLabel,
            show(client){
                this.client = client
                this.dialog = true
            },
            hide(){
                var vm = this
                vm.dialog = false
                vm.$nextTick(function(){
                    this.client = null
                })
            },
            async saveClient(){

                var vm = this
                if(!vm.currentProvider || !vm.client) return

                vm.loading = true
                const response = await ApiUtils.makePatch(
                        `providers/${vm.currentProvider.id}/client/${vm.client.id}`,
                        null,
                        vm.$refs.patientForm.getUserData()
                )
                vm.loading = false

                if(response.ok){
                    const json = await response.json()
                    vm.$emit('success', json.result.user)
                    vm.showSnackBar({
                        text: `${getLabel('commons.client.singular')} actualizado correctamente`,
                        color: 'success'
                    })
                    return
                }

                const json = await response.json()
                var err = json.message
                if(json.result.dni){
                    err += `: ${json.result.dni}`
                }

                vm.showSnackBar({
                    text: err,
                    color: 'error'
                })

            }
        },
        computed: {
                ...mapState(['currentProvider']),
            reasonError(){
                var vm = this
                if(!vm.reason){
                    return 'El motivo de la cita es obligatorio'
                }

                return ''

            },
            valid(){
                var vm = this
                return ((vm.reason && vm.reason !== 'other') || (vm.customReason && vm.reason === 'other'))
            },
            baseReasons(){
                return [
                    {
                        text: `El ${getLabel('commons.client.singular').toLowerCase()} encontro hora en otro centro`,
                        value: 'another_institution'
                    },
                    {
                        text: `No se pudo contactar al ${getLabel('commons.client.singular').toLowerCase()}`,
                        value: 'cant_contact_client'
                    },
                    {
                        text: `Otro`,
                        value: 'other'
                    },
                ]
            }
        },
        watch:{
            reason(val){}
        }

    }
</script>
